/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import IconButton from '@mui/material/IconButton'
import Divider from '@mui/material/Divider'
import Link from '@mui/material/Link'

import '../Styles/App/Footer/Footer.css'
import { useDispatch, useSelector } from 'react-redux'
// import imgBarterFooter from '../Images/logo-barter-sin-fondo.webp'
import imgBarterFooter from '../Images/logo-barter-sin-fondo.png'
import fiserVIcon from '../Images/fiserVIcon.png'
import openPay from '../Images/openPayIcon.png'

import facebook from '../Images/Icons/facebook.svg'
import instagram from '../Images/Icons/instagram.svg'
import tiktok from '../Images/Icons/tiktok.svg'
import Button from '@mui/material/Button'
import { useNavigate } from 'react-router-dom'
import {
  MB_TERMINOS_CONDICIONES,
  MB_AVISO_PRIVACIDAD,
  MB_FAQS,
  MB_FACTURACION,
} from '../Constants/routesConstants'

import {
  gtmPreevaluacion,
  gtmVendeUNL,
  gtmEmpenaeUNL,
  gtmGoShopyUNL,
  gtmTerminosUNL,
  gtmAvisosUNL,
  gtmGoDevolucionesUNL,
  gtmGoFaqsUNL,
  gtmGoFacebookUNL,
  gtmGoInstagramUNL,
  gtmGoTikTokUNL,
  gtmGoTo_ProcesoAutenticacion_Log,
  gtmApartaUNL,
  gtmFacturacionUNL,
} from '../Constants/GoogleTagManager/gtmConstants'

const Footer = () => {
  const navigate = useNavigate()
  const userLogin = useSelector((state) => state.userLogin)
  const { loading, error, userInfo } = userLogin

  const ventasUNL = () => {
    gtmVendeUNL()
    navigate('/consigna')
  }

  const empenosUNL = () => {
    gtmEmpenaeUNL()
    navigate('/empeno')
  }
  const apartarUNL = () => {
    gtmApartaUNL()
    navigate('/apartar')
  }
  const facturacionUNL = () => {
    gtmFacturacionUNL()
    navigate('/facturacion')
  }
  const preevaluacion = () => {
    gtmPreevaluacion()
    navigate('/con-emp')
  }

  return (
    <div className="ContainerFooter">
      <div className="cardFooter">
        {/* <div className="sectionf1">
          <div className="columns">
            <p className="title">Servicios</p>
            <Button
              onClick={function () {
                userInfo ? preevaluacion() : ventasUNL()
              }}
              className="BtnHeaderMb"
            >
              Ventas
            </Button>
            <Button
              onClick={function () {
                userInfo ? preevaluacion() : empenosUNL()
              }}
              className="BtnHeaderMb"
            >
              Empeños
            </Button>
            <Button
              onClick={function () {
                userInfo ? preevaluacion() : apartarUNL()
              }}
              className="BtnHeaderMb"
            >
              Apartados
            </Button>
            <Button
              onClick={function () {
                gtmGoShopyUNL()
                window.open('https://founditpreloved.com/', '_blank')
              }}
              className="BtnHeaderMb"
            >
              Tienda en línea
            </Button>
          </div>
          <div className="columns">
            <p className="title">Legales</p>
            <Button
              onClick={function () {
                facturacionUNL()
                navigate(MB_FACTURACION)
              }}
              className="BtnHeaderMb"
            >
              Facturación
            </Button>
            <Button
              onClick={function () {
                gtmGoFaqsUNL()
                navigate(MB_FAQS)
              }}
              className="BtnHeaderMb"
            >
              FAQs
            </Button>
            <Button
              onClick={function () {
                gtmAvisosUNL()
                navigate(MB_AVISO_PRIVACIDAD)
              }}
              className="BtnHeaderMb"
            >
              Aviso de privacidad
            </Button>
            <Button
              onClick={function () {
                gtmTerminosUNL()
                navigate(MB_TERMINOS_CONDICIONES)
              }}
              className="BtnHeaderMb"
            >
              Términos y condiciones
            </Button>
            <Button
              onClick={function () {
                gtmGoDevolucionesUNL()
                window.open(
                  'https://founditpreloved.com/pages/devoluciones-y-garantias',
                  '_blank'
                )
              }}
              className="BtnHeaderMb"
            >
              Devoluciones y garantías
            </Button>
          </div>
          <div className="columnscontact">
            <p className="title">Contacto</p>
            <div className="columninfo">
              <span className="spanHeaderMb">contacto@founditpreloved.com</span>
              <span className="spanHeaderMb">56 4181 9020</span>
              <span className="spanHeaderMb">
                Calle Av. Río San Joaquín 436, Piso 10, Amp Granada, Miguel
                Hidalgo, 11529 Ciudad de México, CDMX
              </span>
              <span className="spanHeaderMb">Lunes a Jueves 9h a 18h</span>
              <span className="spanHeaderMb">Viernes 9h a 17h</span>
            </div>
          </div>
        </div>
        <Divider className="DividerFooter" /> */}
        <div className="sectionf2">
          <img src="https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/FoundIT+Logos/Foundit+Logo+BLACK.png" />
          {/* <div className="redesSociales">
            <IconButton
              onClick={function () {
                gtmGoFacebookUNL()
                window.open(
                  'https://www.facebook.com/profile.php?id=61561594710798&locale=es_LA',
                  '_blank'
                )
              }}
            >
              <img src="https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Iconos/Facebook_1.png" />
            </IconButton>
            <IconButton
              onClick={function () {
                gtmGoInstagramUNL()
                window.open(
                  'https://www.instagram.com/foundit_preloved/?igsh=NjN2cWdkZnZpd250',
                  '_blank'
                )
              }}
            >
              <img src="https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Iconos/Instagram_1.png" />
            </IconButton>

            <IconButton
              onClick={function () {
                gtmGoTikTokUNL()
                window.open(
                  'https://www.tiktok.com/@foundit_preloved?_t=8oVpfdt9tsE&_r=1',
                  '_blank'
                )
              }}
            >
              <img src="https://barterluxe-mx.s3.us-east-2.amazonaws.com/FounditWeb/Desktop/Iconos/TikTok_1.png" />
            </IconButton>
          </div> */}
          <span className="derechosR">Derechos Reservados Foundit 2024</span>
        </div>
      </div>
    </div>
    
  )
}

export default Footer
